/** Player settings, persisted to localStorage. */
import { Settings, Quality } from '../types'

const KEY = 'bluebob_settings'

const DEFAULTS: Settings = {
  master: 0.8,
  music: 0.55,
  sfx: 0.9,
  quality: detectDefaultQuality(),
  reduceMotion: prefersReducedMotion(),
  resolution: 0, // 0 = native panel resolution
}

function prefersReducedMotion(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
  } catch {
    return false
  }
}

function detectDefaultQuality(): Quality {
  try {
    const mobile = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)
    const dpr = window.devicePixelRatio || 1
    if (mobile) return dpr > 2 ? 'medium' : 'low'
    return 'high'
  } catch {
    return 'medium'
  }
}

let current: Settings = load()
const listeners = new Set<(s: Settings) => void>()

function load(): Settings {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) return { ...DEFAULTS, ...JSON.parse(raw) }
  } catch {
    /* ignore */
  }
  return { ...DEFAULTS }
}

function save(): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(current))
  } catch {
    /* ignore */
  }
}

export function getSettings(): Settings {
  return current
}

export function updateSettings(patch: Partial<Settings>): Settings {
  current = { ...current, ...patch }
  save()
  for (const fn of listeners) fn(current)
  return current
}

export function onSettingsChange(fn: (s: Settings) => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}
